import styled, { css } from 'styled-components';
import { Button } from 'antd';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.catskillWhite};
  padding: 10px 15px 10px 24px;
  color: ${({ theme }) => theme.colors.gullGray};
  margin-top: 20px;
  min-height: 107px;
  ${({ isShowContacts }) => isShowContacts && css`
    height: 100%
  `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 13px;
`;

export const LabelWrapper = styled.div`
  width: 100%;
  display: inline-grid;
  grid-template-columns: 1fr 0.7fr;
  
  span {
    margin-right: 9px;
  }
`;

export const ButtonS = styled(Button)`
  background-color: ${({ theme }) => theme.colors.geyser};
  border: none;
  color: ${({ theme }) => theme.colors.gullGray};
  padding: 0 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  height: 25px;
  box-shadow: none;
  text-shadow: none;
  align-self: flex-end;
  
  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.gullGray};
    background-color: ${({ theme }) => theme.colors.geyserDarken};
  }
  
  > .anticon {
    line-height: 0.6;
  }
`;

export const Client = styled.div`
  display: flex;
  justify-content: space-between;
  
  &:not(:last-child) {
    margin-bottom: 7px;
  }
  
  b {
    font-weight: 700;
    font-size: 15px;
    line-height: 1.2; 
    color: ${({ theme }) => theme.colors.prussianBlue};
    margin-right: 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/request-clients/styled-components.js